import { Controller } from "@hotwired/stimulus"
import { Collapse } from "bootstrap"

export default class extends Controller {
  static targets = ["button"]
  static values = {
    selector: String
  }

  expandAll(event) {
    event.preventDefault()

    const sections = this.element.querySelectorAll(this.selectorValue)
    const shouldExpand = Array.from(sections).some((element) => !element.classList.contains("show"))

    sections.forEach((element) => {
      const collapse = Collapse.getOrCreateInstance(element, { toggle: false })
      if (shouldExpand) {
        collapse.show()
      } else {
        collapse.hide()
      }
    })

    this.buttonTarget.textContent = shouldExpand ? "Collapse all" : "Expand all"
  }
}
